import React from 'react';
import {isFromAccountingTeam, isFromTechTeam} from '../../../auth/UserPermissions';
import Box from '@amzn/awsui-components-react/polaris/box';
import PermissionsModal from '../../PermissionsModal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import ContentLayout from '@amzn/awsui-components-react/polaris/content-layout';
import Header from '@amzn/awsui-components-react/polaris/header';
import Button from '@amzn/awsui-components-react/polaris/button';
import Container from '@amzn/awsui-components-react/polaris/container';
import {ProgressBar} from '@amzn/awsui-components-react';
import TestExecutionPieChart from './TestExecutionPieChart';
import * as paths from '../../../util/paths';


export default function ViewDetailsDashboard(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());


    const getRequestHeader = () => {
        return 'Requester: ' + props.request.userLogin + ' | Test: ' + props.request.testPurpose;
    }

    // FIXME
    const getProcessedTestCasesPercent = () => {
        return 69;
    }

    const getTestCaseCount = () => {
        return 126;
    }

    const getAddTestCasesPath = () => {
        return paths.getRelativePath(paths.MANUAL_TESTING_ADD_TEST_CASES_TO_REQUEST)
            .replace(':request_id', props.request.identifier);
    }

    return (
        <Box>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <ContentLayout
                    header={
                        <SpaceBetween size="m">
                            <Header
                                variant="h1"
                                description="Review the output of the tests executed"
                                actions={
                                <SpaceBetween size='xs' direction='horizontal' >
                                    <Button
                                        key='add-test-cases-button'
                                        href={getAddTestCasesPath()}
                                    >
                                        Add More Test Cases
                                    </Button>
                                    <Button disabled={true}>
                                        Retry Failed Test Cases
                                    </Button>
                                </SpaceBetween>
                                }
                            >
                                {getRequestHeader()}
                            </Header>
                        </SpaceBetween>
                    }
                >
                    <SpaceBetween size='l' direction='vertical'>
                        <Container
                            header={
                                <Header
                                    variant="h2"
                                    description='How many test cases have been processed till now'
                                >
                                    {'Number of Test Cases - ( ' + getTestCaseCount() + ' )'}
                                </Header>
                            }
                        >
                            <ProgressBar
                                value={getProcessedTestCasesPercent()}
                                label="Test Execution Progress"
                            />
                        </Container>
                        <Container
                            header={
                                <Header
                                    variant="h2"
                                    description='If possible, this section shows the pass/fail status of tests'
                                >
                                    Test Outcome
                                </Header>
                            }
                        >
                            <TestExecutionPieChart />
                        </Container>
                    </SpaceBetween>
                </ContentLayout>
            </SpaceBetween>}
        </Box>
    );
}